import { formatDurationFr } from "@/lib/verdict-format";

type Props = {
  saisineDate: string;
  saisineTime: string;
  durationMinutes: number;
  question: string;
  headline: string;
  subHeadline: string;
};

export function VerdictHeadline({
  saisineDate,
  saisineTime,
  durationMinutes,
  question,
  headline,
  subHeadline,
}: Props) {
  return (
    <div data-testid="verdict-headline">
      <div
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: 28,
          color: "var(--qv3-ink)",
          letterSpacing: "-0.03em",
          marginBottom: 6,
        }}
      >
        Hōjin<span style={{ color: "var(--qv3-gold)" }}>.</span>
      </div>
      <div
        data-testid="verdict-question"
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "italic",
          fontWeight: 400,
          fontSize: 22,
          color: "var(--qv3-grey-500)",
          marginBottom: 20,
          lineHeight: 1.35,
        }}
      >
        {question || "—"}
      </div>

      <div
        style={{
          marginBottom: 40,
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <span
          aria-hidden
          style={{
            width: 24,
            height: 0.5,
            background: "var(--qv3-gold)",
            display: "inline-block",
          }}
        />
        <span
          style={{
            fontFamily: "var(--qv3-font-mono)",
            fontSize: 10,
            color: "var(--qv3-grey-500)",
            letterSpacing: 2.5,
            textTransform: "uppercase",
          }}
        >
          Saisi le{" "}
          <span style={{ color: "var(--qv3-ink)", fontWeight: 500 }}>
            {saisineDate}
          </span>{" "}
          à{" "}
          <span style={{ color: "var(--qv3-ink)", fontWeight: 500 }}>
            {saisineTime}
          </span>{" "}
          · Verdict rendu en{" "}
          <span
            data-testid="verdict-duration"
            style={{ color: "var(--qv3-ink)", fontWeight: 500 }}
          >
            {formatDurationFr(durationMinutes)}
          </span>
        </span>
      </div>

      <h1
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "normal",
          fontWeight: 300,
          fontSize: "clamp(48px, 8vw, 84px)",
          color: "var(--qv3-ink)",
          letterSpacing: "-0.04em",
          lineHeight: 0.95,
          margin: "0 0 16px 0",
        }}
      >
        {headline}
      </h1>
      <p
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: "clamp(22px, 3vw, 30px)",
          color: "var(--qv3-gold)",
          lineHeight: 1.3,
          letterSpacing: "-0.02em",
          maxWidth: 580,
          margin: "0 0 56px 0",
        }}
      >
        {subHeadline}
      </p>
    </div>
  );
}

export default VerdictHeadline;
